import React from 'react';
import PropTypes from 'prop-types';
import './ClothedEyeLoader.css';

/**
 * Unified ClothedEye Loader Component
 * 
 * Features:
 * - Logo text at top with orange color
 * - BMDITS tagline below in white
 * - Spinning logo centered
 * - Loading message at bottom
 * - Consistent sizing and styling
 * - Responsive design
 */
const ClothedEyeLoader = ({ 
  size = 'medium',      // 'small', 'medium', 'large' 
  showTagline = true,   // Show "BMDITS" tagline
  showLogo = true,      // Show logo text at top
  message = null,       // Optional loading message
  className = '',       // Additional CSS classes
  theme = 'auto',       // 'auto', 'dark', 'light' - controls color for background contrast
  fullscreen = false    // Whether to use full-screen styling
}) => {
  
  const sizeClasses = {
    small: 'clothedeye-loader--small',
    medium: 'clothedeye-loader--medium', 
    large: 'clothedeye-loader--large'
  };

  const themeClasses = {
    auto: 'clothedeye-loader--auto',
    dark: 'clothedeye-loader--dark',
    light: 'clothedeye-loader--light'
  };

  return (
    <div className={`clothedeye-loader ${sizeClasses[size]} ${themeClasses[theme]} ${fullscreen ? 'clothedeye-loader--fullscreen' : ''} ${className}`}>
      {/* Logo text at top */}
      {showLogo && (
        <div className="clothedeye-loader__logo-text">
          <img 
            src="/assets/svgs/clothedEye-text.svg" 
            alt="CLOTHED EYE" 
            className="clothedeye-loader__logo-text-image"
          />
        </div>
      )}
      
      {/* BMDITS tagline below logo text */}
      {showTagline && (
        <div className="clothedeye-loader__tagline">
          <img 
            src="/assets/svgs/clothedEye_BMDITS.svg" 
            alt="BMDITS" 
            className="clothedeye-loader__tagline-image"
          />
        </div>
      )}
      
      {/* Spinning logo centered */}
      <div className="clothedeye-loader__logo">
        <div className="clothedeye-loader__logo-container">
          {/* Spinning outer ring */}
          <img 
            src="/assets/svgs/clothedEye-loader-spin.svg" 
            alt="" 
            className="clothedeye-loader__spin"
          />
          {/* Static inner logo */}
          <img 
            src="/assets/svgs/clothedEye-loader-static.svg" 
            alt="ClothedEye" 
            className="clothedeye-loader__static"
          />
        </div>
      </div>
      
      {/* Loading message at bottom */}
      {message && (
        <p className="clothedeye-loader__message">{message}</p>
      )}
    </div>
  );
};

ClothedEyeLoader.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showTagline: PropTypes.bool,
  showLogo: PropTypes.bool,
  message: PropTypes.string,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['auto', 'dark', 'light']),
  fullscreen: PropTypes.bool
};

export default ClothedEyeLoader;